import React from 'react'

import Notification from '../system/notification'

function handleReloadClick(event) {
  const { target } = event
  target.innerText = 'Cargando...'
  target.disabled = true
  target.style.opacity = '0.5'
  window.location.reload()
}

export function messageErrorLoad() {
  return Notification.error({
    content: React.createElement(
      'div',
      {
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
        },
      },
      React.createElement('div', null, 'Error en la red '),
      React.createElement(
        'button',
        {
          onClick: handleReloadClick,
          style: {
            border: '2px solid #ff0000',
            padding: '3px 8px',
            borderRadius: '4px',
            fontWeight: '500',
            color: '#ff0000',
            fontSize: '13px',
            marginLeft: '12px',
          },
          type: 'button',
        },
        'RECARGAR',
      ),
    ),
    duration: 0,
  })
}

